import { render } from "./ip_confirmed.vue?vue&type=template&id=a6e466f2"
import script from "./ip_confirmed.vue?vue&type=script&lang=js"
export * from "./ip_confirmed.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__